/* eslint-disable no-useless-escape */
export default () => {
  if (window.ISDIN_URL) {
    // eslint-disable-next-line
    return window.ISDIN_URL === 'https://www-preview.isdin.com/' ||
      /:\/\/([^\/]+)/.exec(window.location.href)[1] ===
        'staging-eu01-isdin.demandware.net' ||
      /:\/\/([^\/]+)/.exec(window.location.href)[1] ===
        'www-demo.isdin.com' ||
      /:\/\/([^\/]+)/.exec(window.location.href)[1] ===
        'www-staging.isdin.com'
      ? 'staging'
      : 'production'
  }

  return process.env.REACT_APP_ENV === 'production'
    ? 'production'
    : 'staging'

}
